import CmsBlock from "app/layout/cmsBlock";
import React from "react";

const ThankYou: React.FC = () => {
  return <CmsBlock id="quote-thank-you" />;
};

export default ThankYou;
